export enum Stage {
  Development,
  Testing,
  Production
}
